exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-body[data-v-614ef630] {\n\toverflow-x: unset !important;\n}\n.card-body[data-v-614ef630] table > tbody > tr > td {\n\tcursor: pointer;\n}\n", ""]);

// exports
